<script setup lang="ts">
import { onMounted } from 'vue';
import { useChat } from '../../composables/useChat';

// Assinatura GLOBAL do realtime do chat (D-CHAT-11). Montado no App.vue enquanto
// o cliente está logado e o canal Web está habilitado. Sem isto, só a thread
// assinava — mensagens do operador não atualizavam a aba "Mensagens" nem o inbox
// quando o cliente estava em outra tela. `useChat()` gerencia o ciclo de vida da
// assinatura pelo contador de referência (não reassina/desassina em duplicidade).
const chat = useChat();

// Carrega o inbox uma vez pro badge/preview iniciarem corretos.
onMounted(() => { void chat.fetchConversations(); });
</script>

<template>
    <span aria-hidden="true" style="display: none" />
</template>
